import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import { Button } from "components/bootstrap";
import Notes from "./Notes";
import { Assets, Dashboards, Events, Logs, Searches } from "./Evidence";
const InvestigationsSmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.4rem;
`;
const SmallItem = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;
const LargeItem = styled.div`
  display: flex;
  flex-direction: row;
  flex: 3;
`;
const InvestigationDetailsContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.4rem;
`;
const InvestigationDetailsSmallColumn = styled.div(
  ({ $showAssetsColumn }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    transition: all 0.33s ease-in-out;
    display: ${$showAssetsColumn ? "inline" : "none"};

    > :not(:last-child) {
      margin-bottom: 0.4rem;
    }
  `
);
const InvestigationDetailsLargeColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
  max-width: 100%;
  overflow: auto;

  > :not(:last-child) {
    margin-bottom: 0.4rem;
  }
`;
const InvestigationDetails = ({ investigation }) => {
  const [showAssetsColumn, setShowAssetsColumn] = useState(true);
  const [expandedSections, setExpandedSections] = useState(["events"]);
  const toggleExpandedSection = (section) => {
    if (expandedSections.includes(section)) {
      setExpandedSections(expandedSections.filter((sectionItem) => sectionItem !== section));
    } else {
      setExpandedSections([...expandedSections, section]);
    }
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(InvestigationsSmallRow, null, /* @__PURE__ */ React.createElement(SmallItem, null, /* @__PURE__ */ React.createElement("h2", { style: { marginRight: "1rem", display: "flex", alignItems: "center" } }, "Assets Column"), /* @__PURE__ */ React.createElement(Button, { "data-testid": "toggle-assets-column", onClick: () => setShowAssetsColumn((cur) => !cur) }, showAssetsColumn ? /* @__PURE__ */ React.createElement(Icon, { style: { marginRight: "0.4rem" }, name: "visibility_off", size: "sm" }) : /* @__PURE__ */ React.createElement(Icon, { style: { marginRight: "0.4rem" }, name: "visibility", size: "sm" }), showAssetsColumn ? "Hide" : "Show")), /* @__PURE__ */ React.createElement(LargeItem, null, /* @__PURE__ */ React.createElement(Dashboards, { investigation }))), /* @__PURE__ */ React.createElement(InvestigationDetailsContentContainer, null, /* @__PURE__ */ React.createElement(InvestigationDetailsSmallColumn, { $showAssetsColumn: showAssetsColumn }, /* @__PURE__ */ React.createElement(Assets, { investigation }), /* @__PURE__ */ React.createElement(Notes, { investigation })), /* @__PURE__ */ React.createElement(InvestigationDetailsLargeColumn, null, /* @__PURE__ */ React.createElement(
    Events,
    {
      investigation,
      isExpanded: expandedSections.includes("events"),
      onToggleExpanded: toggleExpandedSection
    }
  ), /* @__PURE__ */ React.createElement(
    Logs,
    {
      investigation,
      isExpanded: expandedSections.includes("logs"),
      onToggleExpanded: toggleExpandedSection
    }
  ), /* @__PURE__ */ React.createElement(
    Searches,
    {
      investigation,
      isExpanded: expandedSections.includes("searches"),
      onToggleExpanded: toggleExpandedSection
    }
  ))));
};
export default InvestigationDetails;
